import React from "react";
import { ReactComponent as HeaderLogo } from "./assets/headerLogo.svg";
import phoneMockup from "./assets/mobile.png";
import "./App.scss";
import { Link } from "react-router-dom";

const App = () => {
  return (
    <div className="container">
      <main className="main-frame">
        <header className="header">
          <div className="header-left">
            <HeaderLogo />
            <div className="logo">FoodZee</div>
          </div>

          <div className="header-right">
            <div className="contactBubble">
              Feel free to contact us if you are looking for some help or
              partnership
            </div>
            <button className="contactButton">info@foodzee.tech</button>
          </div>
        </header>

        <main className="mainContent">
          {/* Left column: text + buttons grouped together */}
          <div className="textColumn">
            <div className="textContent">
              Your Personal AI Assistant for Weight Loss and Balanced Nutrition
            </div>
            <div className="actionButtons">
              <button
                className="quizButton"
                onClick={() => window.open("http://quiz.foodzee.tech/", "_blank")}
              >
                Start Quiz
              </button>
              <button
                className="loginButton"
                onClick={() => window.open("https://pwa-stage.foodzee.tech/", "_blank")}
              >
                Log In
              </button>
            </div>
          </div>

          <img src={phoneMockup} alt="Phone Mockup" className="phoneMockup" />
        </main>

        <footer className="footer">
          <div className="footer-left">
            <span className="footer-left-first">POFKARIO HOLDINGS LIMITED</span>
            <span className="footer-left-second">
              Thessalonikis 43, office/flat 301 Thessaloniki Court, 3025
              Limassol, Cyprus
            </span>
          </div>

          <div className="footer-right">
            <span className="footer-right-first">info@foodzee.tech</span>
            <span className="footer-right-second">+357 99 658 229</span>
          </div>

          <div className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms-of-use" className="footer-link">Terms of Use</Link>
            <Link to="/refund-terms" className="footer-link">Refund & Cancellation Policy</Link>
            <a href="https://pwa-stage.foodzee.tech/" target="_blank" rel="noreferrer" className="footer-link">
              Log In
            </a>
            <a href="https://sub.abiens.app/terminate" target="_blank" rel="noreferrer" className="footer-link">
              Cancel Subscription
            </a>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default App;